import React, { Component } from 'react';
import { connect } from "react-redux";
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {setSelectedParameter} from 'actions/index.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import {setSelectedParameterFlashing} from 'actions/index.js';

class MixTrackParametersView extends Component {
    getParameters() {
        if (this.props.track === undefined) {
            return [];
        }

        let trackData = this.props.track.trackData;
        return [[
            trackData.durationParameter,
            trackData.transposeParameter,
            trackData.chopParameter],
            [trackData.velocityParameter,
            trackData.attackParameter,
            trackData.releaseParameter],
            [trackData.pitchAttackParameter,
             trackData.pitchDecayParameter,
            trackData.pitchSustainParameter,
            trackData.pitchReleaseParameter]
        ];
    }

    render() {
        return (
            <div className="track-parameters">
              {this.getParameters()
                  .map(parameters =>
                       <ParametersBox
                         sequencerEngine={this.props.sequencerEngine}
                         parameters={parameters}/>)}
            </div>
        );
    }
}

class ParametersBox extends Component {
    render() {
        return (
            <div className="parameters-box">
              {this.props.parameters
                  .map(parameters =>
                       <Parameter
                         sequencerEngine={this.props.sequencerEngine}
                         parameter={parameters}/>)}
            </div>
        );
    }
}    

class ConnectedParameter extends Component {
    onChange(value) {
        this.props.setSelectedParameter(this.props.parameter);
        this.props.setSelectedParameterFlashing(this.props.parameter);
        setTimeout(() => {
            this.props.setSelectedParameterFlashing(undefined);
        }, 3000);
    }

    render() {
        let step = (this.props.parameter.originalMax - this.props.parameter.originalMin) <= 20 ? 0.01  : 1;
        let isSelected = this.props.isSelected;
        return (
            <div className={isSelected ? "selected parameter" :"parameter"}>
                <EffectParameterSlider
                  name={this.props.parameter.name}
                  parameter={this.props.parameter}
                  isParameter={true}
                  lfoEnabled={true}
                  sequencerEngine={this.props.sequencerEngine}
                  value={this.props.value}
                  onParameterChanged={(e) => this.onChange()}
                  step={step}
                  max={this.props.parameter.originalMax}
                  min={this.props.parameter.originalMin}
                  orientation="horizontal"
                  reversed={false}
                /> 
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let id = props.parameter.id;
    return {
        value: state.effects.effectParameters[id],
        isSelected: state.mix.selectedParameter === props.parameter
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedParameter: parameter => dispatch(setSelectedParameter(parameter)),
        setSelectedParameterFlashing: parameter => dispatch(setSelectedParameterFlashing(parameter)),
    }
};

const Parameter = connect(mapStateToProps, mapDispatchToProps)(ConnectedParameter);

export default connect(null, null)(MixTrackParametersView);
